<template>
	<shark-loader v-if="galleryImagesLoading"/>
	<div class="gallery-wrapper" v-else-if="galleryImagesLoading === false" >
		<stack :column-min-width="320" :gutter-width="4" :gutter-height="0" monitor-images-loaded class="gallery" ref="stack">
			<stack-item v-for="galleryImage in galleryImages" :key="galleryImage.id" class="image-frame">
				<img :src="galleryImage.image" :alt="galleryImage.caption || ''">
				<resize-observer @notify="handleResize" />
			</stack-item>
		</stack>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { Stack, StackItem } from 'vue-stack-grid';
import { ResizeObserver } from 'vue-resize'

import 'vue-resize/dist/vue-resize.css';

export default {
	name: 'GalleryHome',
	components: {
		Stack,
		StackItem,
		ResizeObserver,
	},
	computed: {
		...mapState(["galleryImagesLoading", "galleryImages"]),
	},
	created() {
		if (this.galleryImagesLoading == null) {
			this.$store.dispatch("loadGalleryImages");
		}
	},
	methods: {
		handleResize() {
			this.$refs.stack.update();
		}
	}
}
</script>

<style lang="scss" scoped>
/* Thanks in part to
 * https://travishorn.com/creating-a-photo-gallery-with-vue-css-grid-3e0a3dd25285
 * for some of this code (also partially used in the template above)! */
.gallery-wrapper {
	position: relative;
	padding: 1.5rem 3rem 1.5rem 3rem;
}
.gallery {
	margin: 0 auto;
}
.image-frame {
	transition: transform 300ms;
	img {
		width: 100%;
    object-fit: contain;
    border-radius: 3px;
	}
}
</style>